import { render, staticRenderFns } from "./SubjectInfectedDetails.vue?vue&type=template&id=f05e6504&"
import script from "./SubjectInfectedDetails.vue?vue&type=script&lang=js&"
export * from "./SubjectInfectedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports